import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';



// import { AppWrap, MotionWrap } from '../../wrapper';
// import './About.scss';
import { urlFor, client } from '../../client';

const About = () => {
  const [abouts, setAbouts] = useState([]);

  useEffect(() => {
    const query = '*[_type == "abouts"]| order(order asc)';

    client.fetch(query).then((data) => {
      setAbouts(data);
    });
  }, []);

  return (
    <>
     
 
    
 <section id="about" className="text-gray-500 bg-white-300 body-font mt-4 bg-blue-100">


   
      <div className="container px-5 py-10 mx-auto text-center lg:px-50 xl:px-40">
        
        <div className="flex flex-col justify-center w-full mb-16">
         
          <h1 className="sm:text-4xl text-4xl font-semibold title-font mb-4 text-black" data-aos='fade-in'>
           Services
          </h1>
          <p className="lg:w-3/4 font-light mx-auto  text-base text-darkBlue" data-aos='fade-in'  >
          Collect, process, analyse and present data from supporting everyday business decisions to driving global change.
          </p>
        </div>
       
  


      <div className="xl:grid  justify-items-center xl:grid-cols-3 xl:gap-2 lg:grid lg:grid-cols-3 lg:gap-2 md:grid md:grid-cols-2 md:gap-2 sm:grid justify-center items-center   space-y-12 space-x-4  ">


        
        {abouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: 'tween' }}
            className="w-48 align-middle "
            key={about.title + index}
          >
            
            <img className=' w-28 justify-center  h-42 rounded-lg object-cover' src={urlFor(about.imgUrl)} alt={about.title} data-aos='flip-right' />
            <h2  className="font-bold text-left mt-10 text-black" data-aos='fade-in' >{about.title}</h2>
            <p className="text-grey-400 mt-10 text-left" data-aos='fade-in'>{about.description}</p>
          </motion.div>
        ))}
      </div>
      </div>
      </section>
    </>
  );
};

export default About